// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"d6756cfb","309":"79c94b1b"}[chunkId] + ".chunk.css";
};